/* PTI membership comparison: on small screens, plan buttons choose which plan's
   column is shown beside the features. A custom element, so theme-editor section
   reloads do not stack listeners. Without JavaScript the full table scrolls. */
(() => {
  if (customElements.get('pti-join-compare')) return;

  class PtiJoinCompare extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;

      this.tabs = Array.from(this.querySelectorAll('[data-pti-join-tab]'));
      this.tabGroup = this.querySelector('[data-pti-join-tabs]');
      this.cells = Array.from(this.querySelectorAll('[data-tier]'));
      if (!this.tabs.length || !this.tabGroup) return;

      const fallback = this.tabs[0].dataset.ptiJoinTab;
      const preferred = this.dataset.defaultTier;
      this.active = this.tabs.some((tab) => tab.dataset.ptiJoinTab === preferred) ? preferred : fallback;

      this.small = window.matchMedia('(max-width: 759px)');
      this.onBreakpoint = () => this.apply();
      this.small.addEventListener('change', this.onBreakpoint);
      this.tabs.forEach((tab) =>
        tab.addEventListener('click', () => {
          this.active = tab.dataset.ptiJoinTab;
          this.apply();
        })
      );

      this.tabGroup.hidden = false;
      this.classList.add('is-enhanced');
      this.apply();
    }

    disconnectedCallback() {
      if (this.small && this.onBreakpoint) this.small.removeEventListener('change', this.onBreakpoint);
    }

    apply() {
      const small = this.small.matches;
      this.tabs.forEach((tab) => tab.setAttribute('aria-pressed', String(tab.dataset.ptiJoinTab === this.active)));
      this.cells.forEach((cell) => {
        cell.hidden = small && cell.dataset.tier !== this.active;
      });
    }
  }

  customElements.define('pti-join-compare', PtiJoinCompare);
})();
